import HomePage from 'pages/HomePage/HomePage'
import React from 'react'

const Qna = () => {
  return (
    <HomePage/>
  )
}

export default Qna